import { LoadingView } from '@core/components';
import { AlertComponent } from '@core/components/atoms/alert-component';
import { colaboradorService } from '@core/services';
import { selectorInformeRendimentos } from '@core/slice/informe-rendimentos.slice';
import { selectorDownloadRendimentos } from '@core/slice/download-rendimentos.slice';
import { getYearFromDate, isFilled } from '@core/utils';
import { AssignmentTwoTone, FileDownloadOutlined } from '@mui/icons-material';
import { Container, Grid, IconButton, Typography } from '@mui/material';
import { useAppSelector } from '@store/hooks';
import React, { useEffect } from 'react';

interface IInformeRendimentosProps { }

export const InformeRendimentos: React.FC<IInformeRendimentosProps> = () => {
    const { data, loading, error } = useAppSelector(selectorInformeRendimentos);
    const { download, downloading, downloadError } = useAppSelector(selectorDownloadRendimentos);

    useEffect(() => {
        colaboradorService.buscarInformesRendimentos();
        console.log('Loaded.');
    }, []);

    const handleDownloadPdf = (dataReferencia: string) => {
        colaboradorService.baixarInformeRendimentos(dataReferencia);
    };

    return (
        <Container maxWidth="xl" sx={{ px: '2rem' }}>
            {/* File download state */}
            {(loading || downloading) && <LoadingView />}
            {downloadError && !downloading ? (
                <AlertComponent type="error" detailed={true} message={downloadError ?? '-'} />
            ) : isFilled(download) && !downloading ? (
                <AlertComponent type="success" detailed={true} message={download ?? 'Arquivo gerado com sucesso.'} />
            ) : (
                ''
            )}

            {/* File list state */}
            {error && !loading ? (
                <AlertComponent type="error" detailed={true} message={error ?? '-'} />
            ) : (
                <>
                    <Typography sx={{ fontSize: '1rem' }} variant="h5">
                        Confira todos os seus rendimentos e informações
                    </Typography>
                    {data.rendimentos
                        ? data.rendimentos.map((rendimento, index) => (
                            <Grid key={index} sx={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginTop: '1.5rem', justifyContent: 'space-between' }}>
                                <Typography sx={{ fontSize: '1rem', gap: '0.5rem', display: 'inline-flex', alignItems: 'center' }}>
                                    <AssignmentTwoTone />
                                    {getYearFromDate(rendimento.anoRendimento)} - {rendimento.apelidoEmpresa}
                                </Typography>
                                <Grid>
                                    <IconButton
                                        onClick={() => handleDownloadPdf(rendimento.anoRendimento)}
                                        sx={{ color: '#5d44c1', width: '2.5rem', height: '2.5rem' }}
                                        title={getYearFromDate(rendimento.anoRendimento)}
                                    >
                                        <FileDownloadOutlined />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))
                        : ''}
                </>
            )}
        </Container>
    );
};
